import { render, staticRenderFns } from "./PaymentBatchesView.vue?vue&type=template&id=57d9cf6d&scoped=true&"
import script from "./PaymentBatchesView.vue?vue&type=script&lang=js&"
export * from "./PaymentBatchesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d9cf6d",
  null
  
)

export default component.exports